import { render, staticRenderFns } from "./I&MTransactions.vue?vue&type=template&id=050aa233&"
import script from "./I&MTransactions.vue?vue&type=script&lang=js&"
export * from "./I&MTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports